<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">调拨工单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsDetail">
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            @change="getDeviceList"
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="deviceList != ''">
          <a-select v-model="type" style="width:120px">
            <a-select-option :value="1">调货网点</a-select-option>
            <a-select-option :value="2">收货网点</a-select-option>
          </a-select>
          <a-select
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            style="width:200px;margin-left:10px"
            placeholder="请选择网点设备"
            v-model="deviceID"
          >
            <a-select-option
              v-for="(item, i) in deviceList"
              :key="i"
              :value="item.device_id"
              >{{ item.device_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <a-select v-model="status" style="width:120px">
            <a-select-option :value="1">待收货</a-select-option>
            <a-select-option :value="2">无差异入库</a-select-option>
            <a-select-option :value="3">待管理介入</a-select-option>
            <a-select-option :value="4">管理通过</a-select-option>
            <a-select-option :value="5">管理驳回</a-select-option>
          </a-select>
        </span>
        <span>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
        <span>
          <a-button @click="getDownloaFd">下载</a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.allocation_time }}</td>
              <td>{{ item.device_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.collect_device_name }}</td>
              <td>{{ item.collect_user_name }}</td>
              <td>
                <p v-show="item.status == 1">待收货</p>
                <p v-show="item.status == 2">无差异入库</p>
                <p v-show="item.status == 3">待管理介入</p>
                <p v-show="item.status == 4">管理通过</p>
                <p v-show="item.status == 5">管理驳回</p>
              </td>
              <td class="operation">
                <a @click="detailPage(item)" style="color:#666">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 详情 -->
    <goodsAllocationDetail
      v-show="showIsDetail"
      :detailVal="detailVal"
      v-on:hideIsDetail="hideIsDetail"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import goodsAllocationDetail from "@/components/equipment/goodsAllocationDetail";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "调拨日期",
        "调货网点",
        "调货人",
        "收货网点",
        "收货人",
        "状态",
        "操作"
      ],
      proList: [],
      showIsDetail: false,
      detailVal: "",
      status: "",
      project_id: "",
      device_id: "",
      collect_device_id: "",
      user_id: "",
      type: 1,
      deviceID: "",
      deviceList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    goodsAllocationDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro();
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getDeviceList() {
      this.deviceID = "";
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
          // console.log(this.deviceList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    backHref() {
      this.showIsDetail = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.status = "";
      this.type = 1;
      this.deviceID = "";
      this.project_id = "";
      this.device_id = "";
      this.collect_device_id = "";
      this.user_id = "";
      this.page = 1;
      this.getData();
    },
    getDownloaFd() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_material_allocation/getListDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&status=" +
        this.status +
        "&project_id=" +
        this.project_id;
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_material_allocation/getlist";
      let params = {
        current_page: this.page,
        per_page: 10,
        token: window.localStorage.getItem("xnwfPcToken"),
        status: this.status,
        project_id: this.project_id,
        device_id: this.type == 1 ? (this.device_id = this.deviceID) : "",
        collect_device_id:
          this.type == 2 ? (this.collect_device_id = this.deviceID) : ""
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      console.log(this.detailVal);
      this.detailVal = item;
      this.showIsDetail = true;
    },
    hideIsDetail(msg) {
      this.showIsDetail = false;
      if (msg) {
        this.reload();
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
